import { User } from 'services/requests';

export const hasUserLockProperties = (row: object): row is User =>
  'isAutoLocked' in row && 'isLocked' in row;

export const hasUserAccountClosedProperty = (row: object): row is User =>
  'accountClosed' in row;
